<template>
  <div class="home">
    <SiestaHeader :is-gameplay="true" />
    <div class="vertical-spacer"></div>
    <div class="horizontal top game-ui">
      <SiestaHints @showHint="showHint" />
      <div class="horizontal-spacer"></div>
      <SiestaTotal :points="game.points" />
      <div class="horizontal-spacer"></div>
      <SiestaRound :round="game.round" :point-value="game.bonusPoints" />
    </div>
    <SiestaTimer class="timer" :percent-complete="percentComplete" />
    <SiestaDifferences
      @loaded="loaded"
      @foundItem="foundItem"
      @missedItem="missedItem"
      ref="differences"
    />
    <SiestaTunein />
    <SiestaHelp @showHelp="showHelp" />
  </div>
</template>

<script>
import SiestaHeader from "@/components/SiestaHeader";
import SiestaTunein from "@/components/SiestaTunein";
import SiestaDifferences from "@/components/gameplay/SiestaDifferences";
import SiestaHints from "@/components/gameplay/SiestaHints";
import SiestaRound from "@/components/gameplay/SiestaRound";
import SiestaTimer from "@/components/gameplay/SiestaTimer";
import SiestaTotal from "@/components/gameplay/SiestaTotal";
import SiestaHelp from "@/components/gameplay/SiestaHelp";

export default {
  name: "activity",
  components: {
    SiestaDifferences,
    SiestaHeader,
    SiestaHints,
    SiestaRound,
    SiestaTimer,
    SiestaTotal,
    SiestaTunein,
    SiestaHelp
  },
  computed: {
    percentComplete() {
      return this.game.percentage;
    },
    game() {
      return this.$store.state.game;
    },
    completed() {
      return this.game.gameCompleted;
    }
  },
  methods: {
    showHint() {
      this.game.showHint();
    },
    foundItem(id) {
      this.game.foundItem(id);
    },
    missedItem() {
      this.game.missedItem();
    },
    showHelp() {
      this.game.pause();
    },
    loaded() {
      console.log("loaded");
    }
  },
  mounted() {
    this.game.continue();
    this.game.playBG();
    this.$gtag.event(`Started Session`, {
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_category: "Gameplay"
    });
  },
  destroyed() {
    this.game.pauseBG();
  },
  created() {
    this.game.initials = "";
    this.game.submitted = false;
  },
  watch: {
    completed(to) {
      if (to) {
        this.$router.push("results");
      }
    },
    hasLoaded(to) {
      console.log(to);
    }
  }
};
</script>

<style lang="scss" scoped>
.home {
  padding: rems(10px);
  position: relative;
}
.game-ui {
  text-align: center;
  max-width: rems(800px);
  margin: rems(30px) auto 0 auto;
}
.horizontal-spacer {
  height: rems(90px);
  margin: 0;
}
.timer {
  margin: rems(20px) 0 rems(10px) 0;
}
</style>
